import { makeStyles } from 'tss-react/mui';

export const useMobileMonthGridStyles = makeStyles()(() => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    width: '100%',
  },
  headerCell: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 8,
    fontFamily: 'Poppins',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '13.2px',
  },
  dayCell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px 0',
    cursor: 'default',
    userSelect: 'none',
    height: 60,
    boxSizing: 'border-box',
  },
  dayCellClickable: {
    cursor: 'pointer',
  },
  selectedWrapper: {
    width: 32,
    height: 44,
    borderRadius: 6,
    backgroundColor: '#4E6DF5',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0,
  },
  dayNumber: {
    fontFamily: 'Poppins',
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: 1.2,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    marginTop: 2,
  },
}));
